"use client";

import React, { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Customerreviews() {
  const widgetRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const injectScript = () => {
      if ((window as any).__elfsightLoaded) return;
      (window as any).__elfsightLoaded = true;
      const script = document.createElement("script");
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.head.appendChild(script);
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          injectScript();
          observer.disconnect();
        }
      });
    }, {
      rootMargin: "600px 0px"
    });
    if (widgetRef.current) {
      observer.observe(widgetRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, []);
  return <section data-section-id="255525" id="customerreviews" className="relative overflow-hidden py-12 md:py-[60px] bg-[linear-gradient(135deg,#081438,#0d1e3a)] text-white w-full mt-0">
      {}
      <div className="absolute top-[-50px] right-[-50px] w-[250px] h-[250px] bg-[#F5A623]/3 rounded-lg pointer-events-none blur-3xl" />

      <div className="page-container relative z-10 flex flex-col w-full max-w-[1240px] mx-auto px-4">
        {}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-10">
          <div className="max-w-[480px]">
            <div className="w-10 h-[2px] bg-[#F5A623] mb-3" />
            <span className="block text-[11px] font-semibold uppercase tracking-[0.1em] text-[#F5A623] mb-2 font-['Manrope']">
              WHAT OUR CUSTOMERS SAY
            </span>
            <h2 className="text-[clamp(26px,3vw,36px)] font-extrabold leading-tight tracking-[-0.02em] text-white mb-4 font-['Manrope']">
              Real Reviews from Real Sydney Homeowners
            </h2>
            <p className="text-[15px] text-white/50 leading-relaxed">
              Every review is verified directly from Google. No fake testimonials — just honest feedback from our customers.
            </p>
          </div>

          {}
          <div className="hidden md:flex flex-col items-center bg-white/4 border border-white/8 rounded-lg p-5 px-7 min-w-[200px]">
            <span className="text-[36px] font-extrabold text-white leading-none mb-2 font-['Manrope']">
              5.0
            </span>
            <div className="flex gap-1 mb-2">
              {[...Array(5)].map((_, i) => <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#F5A623" className="text-[#F5A623]" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 17.75l-6.172 3.245 1.179-6.873-4.993-4.867 6.9-1.002L12 2l3.086 6.253 6.9 1.002-4.993 4.867 1.179 6.873z" />
                </svg>)}
            </div>
            <span className="text-[12px] font-semibold text-white/50 font-['Manrope']">300+ Google Reviews</span>
          </div>
        </div>

        {}
        <div className="w-full min-h-[400px]" ref={widgetRef}>
          <div className="elfsight-app-e48a8977-4fbd-41d9-a656-6a6d33f0fcb1" data-elfsight-app-lazy></div>
        </div>

        {}
        <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-6">
          <Button asChild className="bg-[#F5A623] hover:bg-[#F5A623]/90 text-[#081438] px-7 py-3.5 h-auto rounded-lg font-bold text-[15px] font-['Manrope'] w-full md:w-auto">
            <Link to="https://maps.app.goo.gl/cRmPoP3fDg61AK6c6" newTab>
              Leave Us a Review <svg className="ml-2 h-4 w-4" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </Button>
          
          <Link to="https://maps.app.goo.gl/cRmPoP3fDg61AK6c6" newTab className="text-[#F5A623] text-[14px] font-bold hover:underline flex items-center">View All 280+ Reviews on Google <svg className="ml-1.5 h-4 w-4" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" data-ast-id="f:/src/pages/HomePageGoldGarageDoor/sections/Customerreviews.tsx|sig:qqzz0y" data-ast-start="4830" data-ast-end="5270"><path d="M5 12h14M12 5l7 7-7 7" data-ast-id="f:/src/pages/HomePageGoldGarageDoor/sections/Customerreviews.tsx|sig:a9ht4u" data-ast-start="5217" data-ast-end="5251"></path></svg></Link>
        </div>
      </div>

      <svg className="absolute bottom-[-1px] left-0 w-full h-16 z-20" viewBox="0 0 1440 120" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M0,32L60,42.7C120,53,240,75,360,74.7C480,75,600,53,720,48C840,43,960,53,1080,58.7C1200,64,1320,64,1380,64L1440,64L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z" fill="#F5A623" />
        <path d="M0,64L60,69.3C120,75,240,85,360,80C480,75,600,53,720,48C840,43,960,53,1080,58.7C1200,64,1320,64,1380,64L1440,64L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z" fill="white" />
      </svg>
    </section>;
}